import { use } from 'i18next';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Button, Col } from 'reactstrap';

interface IGenericButtonProps {
  colNumber?: number;
  buttonClassName?: string;
  id?: string;
  switchCondition?: boolean;
  onClick?: () => void;
  iconClassName?: string;
  switchedIconClassName?: string;
  buttonText?: string;
  clickable?: boolean;
  buttonTextClassName?: string;
  colClassName?: string;
  tooltipText?: string; 
  tooltipClassName?: string;
}

const GenericButton: React.FC<IGenericButtonProps> = ({
  colNumber = 0,
  buttonClassName = "",
  id = "",
  switchCondition = false,
  onClick = () => {},
  iconClassName = "",
  switchedIconClassName = "",
  buttonText = "",
  clickable = true,
  buttonTextClassName = "",
  colClassName= "",
  tooltipText = "",
  tooltipClassName = ""
}) => {
const [switched, setSwitched] = useState(false);

  useEffect(() => {
      setSwitched(switchCondition);
  }, [switchCondition]);
  
  const buttonContent = (
    <div className="tooltip-wrapper"> {/* Avvolgi il bottone in un div */}
      <Button
        id={id}
        outline //queste 2 impostazione sono obbigatorie per contrastare gli effetti generici dei bottoni sul player
        style={{ boxShadow: 'none' }} //queste 2 impostazione sono obbigatorie per contrastare gli effetti generici dei bottoni sul player
        className={`${buttonClassName}`}
        onClick={onClick}
        data-tip={tooltipText}
      >
        {switched ? (
          <i className={`${switchedIconClassName}`}></i>
        ) : (
          <i className={`${iconClassName}`}></i>
        )}
        {buttonText && <span className={buttonTextClassName}>{buttonText}</span>}
      </Button>
      {tooltipText && clickable && <span className={"tooltip-text " + tooltipClassName}>{tooltipText}</span>} {/* Tooltip */}
    </div>
  );

  return (
    <>
      {colNumber > 0 ? (
        <Col xs={colNumber} md={colNumber} lg={colNumber} xl={colNumber} className={colClassName}>
          {buttonContent}
        </Col>
      ) : (
        buttonContent
      )}
    </>
  );
};

export default observer(GenericButton);